var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"title-line"},[_c('i',{class:_vm.iconclass+' iconstyle'}),_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"bottom-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }